var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Calendar',{style:({
    fontFamily: _vm.settings.font,
  }),attrs:{"locale":"fi","columns":_vm.$screens({ default: 1 }),"rows":_vm.$screens({ default: this.settings.showReservationCalendarMonths }),"is-expanded":_vm.$screens({ default: true, lg: true, xl: true }),"attributes":_vm.attrs,"disabled-dates":_vm.getDisabledDates}})
}
var staticRenderFns = []

export { render, staticRenderFns }